import { TypographyColors, TypographyVariants } from '@lyearn/ui';

export const typography: {
  variant?: TypographyVariants;
  color?: TypographyColors;
  className?: string;
} = { variant: 'heading-xs' };
